export default [{
  "name": "scaleHub",
  "url": "hubs/v1/scaleHub?tenantId={tenantId}&containerId={containerId}&scaleId={scaleId}"
}, {
  "name": "notificationHub",
  "url": "hubs/v1/notificationHub?tenantId={tenantId}"
}, {
  "name": "applicationStateHub",
  "url": "hubs/v1/applicationStateHub"
}]